<template>
  <section class="details">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="用户管理" name="first">用户管理</el-tab-pane>
      <el-tab-pane label="配置管理" name="second">配置管理</el-tab-pane>
      <el-tab-pane label="角色管理" name="third">角色管理</el-tab-pane>
      <el-tab-pane label="定时任务补偿" name="fourth">定时任务补偿</el-tab-pane>
    </el-tabs>
  </section>
</template>

<script>
export default {
    data(){
        return {
            activeName:"second"
        }
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      }
    }
};
</script>

<style scoped>
.title {
  border-bottom: solid #efefef 1px;
  padding: 10px 0;
  font-size: 20px;
  color: #f9415d;
}
.title::before {
  content: "";
  display: inline-block;
  width: 12px;
  height: 12px;
  border: solid #f9415d 2px;
  margin-right: 10px;
  rotate: 10px;
  transform: rotate(45deg);
}
.title span {
  color: #ccc;
}
.detailsPic {
  background: url(../../../assets/image/detailsPic.png) center center no-repeat;
  background-size: 1254px 447px;
  width: 1254px;
  height: 447px;
  margin-top: 20px;
}
</style>
